export default __webpack_public_path__ + "static/carefirst-1bbafc0d3329e7ad88da1e09de7c8c5f.svg";